module.exports = __webpack_public_path__ + "static/media/chevron_down.af2354d2.svg";